import React from 'react'
import AdminLayout from '../../components/layout/AdminLayout'
import PurchaseBox from '../../components/manager/PurchaseBox'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import CurriculumLayout from '../../components/layout/CurriculumLayout'
import BillingBox from '../../components/admin/BillingBox'

const BillingIndividual = () => {
  return (
    <AdminLayout>
      <AdminContentLayout>
        <CurriculumLayout title={'Billing'}>
          <BillingBox />
        </CurriculumLayout>
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default BillingIndividual
